export default function ResultsWinsIconMain() {
  return (
    <svg
      width='49'
      height='48'
      viewBox='0 0 49 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.8312 26.2397H18.9263C18.3514 26.2397 17.8848 26.7064 17.8848 27.2813V38.9577C17.8848 39.3193 18.0722 39.6551 18.3806 39.8451C18.6889 40.0351 19.073 40.0509 19.3955 39.8876L23.8784 37.6245L28.3613 39.8876C28.5096 39.9626 28.6704 39.9993 28.8304 39.9993C29.0204 39.9993 29.2095 39.9476 29.3762 39.8451C29.6845 39.6551 29.8719 39.3202 29.8719 38.9577V27.2813C29.8719 26.7064 29.4053 26.2397 28.8304 26.2397H28.8312Z'
        fill='url(#paint0_linear_61_3882)'
      />
      <path
        d='M43.2054 16.3357H29.7642C29.1893 16.3357 28.7227 16.8023 28.7227 17.3773V21.9235C28.7227 22.4984 29.1893 22.9651 29.7642 22.9651H38.6592C41.7406 22.9651 44.247 20.4586 44.247 17.3773C44.247 16.8023 43.7804 16.3357 43.2054 16.3357Z'
        fill='url(#paint1_linear_61_3882)'
      />
      <path
        d='M40.5843 20.8821H27.1431C26.5682 20.8821 26.1016 21.3487 26.1016 21.9236V26.4699C26.1016 27.0448 26.5682 27.5114 27.1431 27.5114H36.0381C39.1195 27.5114 41.6259 25.005 41.6259 21.9236C41.6259 21.3487 41.1593 20.8821 40.5843 20.8821Z'
        fill='url(#paint2_linear_61_3882)'
      />
      <path
        d='M17.9828 16.3352H4.54157C3.96662 16.3352 3.5 16.8018 3.5 17.3768C3.5 20.4581 6.00643 22.9646 9.0878 22.9646H17.9828C18.5577 22.9646 19.0243 22.4979 19.0243 21.923V17.3768C19.0243 16.8018 18.5577 16.3352 17.9828 16.3352Z'
        fill='url(#paint3_linear_61_3882)'
      />
      <path
        d='M20.603 20.8813H7.16266C6.58772 20.8813 6.12109 21.348 6.12109 21.9229C6.12109 25.0043 8.62752 27.5107 11.7089 27.5107H20.6039C21.1788 27.5107 21.6454 27.0441 21.6454 26.4691V21.9229C21.6454 21.348 21.1788 20.8813 20.6039 20.8813H20.603Z'
        fill='url(#paint4_linear_61_3882)'
      />
      <path
        d='M23.8742 31.9708C30.4936 31.9708 35.8597 26.6047 35.8597 19.9853C35.8597 13.3659 30.4936 7.99976 23.8742 7.99976C17.2548 7.99976 11.8887 13.3659 11.8887 19.9853C11.8887 26.6047 17.2548 31.9708 23.8742 31.9708Z'
        fill='url(#paint5_linear_61_3882)'
      />
      <path
        d='M30.2663 20.1972C30.8338 19.5798 31.0188 18.7349 30.7588 17.9366C30.4996 17.1383 29.8539 16.5634 29.0315 16.3976L27.0166 15.991C26.9567 15.9785 26.905 15.9418 26.875 15.8885L25.8659 14.0978C25.4543 13.367 24.7069 12.9304 23.8686 12.9304C23.0304 12.9304 22.2829 13.367 21.8713 14.0978L20.8622 15.8893C20.8322 15.9426 20.7806 15.9801 20.7206 15.9918L18.7058 16.3984C17.8834 16.5642 17.2376 17.14 16.9784 17.9374C16.7193 18.7357 16.9035 19.5806 17.4709 20.1981L18.8624 21.7112C18.9041 21.7562 18.9233 21.8171 18.9166 21.8771L18.6808 23.9194C18.5841 24.7526 18.9324 25.545 19.6107 26.0375C20.0132 26.33 20.4806 26.4791 20.9531 26.4791C21.2764 26.4791 21.603 26.4091 21.913 26.2675L23.782 25.4117C23.8378 25.3867 23.9011 25.3867 23.9569 25.4117L25.8259 26.2675C26.5884 26.6166 27.4491 26.5308 28.1282 26.0375C28.8073 25.5442 29.1548 24.7526 29.0581 23.9194L28.8223 21.8771C28.8156 21.8162 28.8348 21.7562 28.8765 21.7112L30.268 20.1981L30.2663 20.1972Z'
        fill='url(#paint6_linear_61_3882)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_61_3882'
          x1='23.8784'
          y1='30.9693'
          x2='23.8784'
          y2='36.2221'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#999999' />
          <stop offset='1' stopColor='#CCCCCC' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_61_3882'
          x1='34.9729'
          y1='19.6504'
          x2='40.9323'
          y2='19.6504'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_61_3882'
          x1='34.3291'
          y1='24.1968'
          x2='38.8403'
          y2='24.1968'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_61_3882'
          x1='13.8165'
          y1='19.6499'
          x2='5.9606'
          y2='19.6499'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_61_3882'
          x1='16.051'
          y1='24.196'
          x2='8.73668'
          y2='24.196'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_61_3882'
          x1='23.8742'
          y1='32.0566'
          x2='23.8742'
          y2='9.40795'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFBD00' />
          <stop offset='1' stopColor='#FFF065' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_61_3882'
          x1='23.8686'
          y1='26.4191'
          x2='23.8686'
          y2='13.1904'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
      </defs>
    </svg>
  );
}
